import { useMemo } from 'react'
import { SelectDropdown, SelectOption } from '../../../../../../../components/SelectDropdown/SelectDropdown'

export interface ObjectTypeDropdownProps {
  options: SelectOption[]
  excludeObjectNames?: Set<string>
  selectedObjectName?: string
  onOptionSelected: (option: SelectOption) => void
  loading?: boolean
  disabled?: boolean
  disabledTitle?: string
}

export const ObjectTypeDropdown: React.FC<ObjectTypeDropdownProps> = ({
  options,
  excludeObjectNames,
  selectedObjectName,
  onOptionSelected,
  loading,
  disabled,
  disabledTitle,
}) => {
  const availableOptions = useMemo(
    () => (excludeObjectNames ? options.filter((o) => !excludeObjectNames.has(o.id) || o.id === selectedObjectName) : options),
    [options, excludeObjectNames, selectedObjectName],
  )
  const initialSelectedOption: SelectOption | null = useMemo(
    () => availableOptions.find((o) => o.id === selectedObjectName) ?? null,
    [availableOptions, selectedObjectName],
  )

  return (
    <div
      className='w-50 input-group-sm'
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
    >
      <div title={disabled ? disabledTitle : undefined}>
        <SelectDropdown
          options={availableOptions}
          initialSelectedOption={initialSelectedOption}
          placeholder='Select Object Type'
          onOptionSelected={onOptionSelected}
          searchable
          loading={loading}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
